import type { EstadoRebatimentoPainel } from '../../dominio/didatico/rebatimentoPainel'
import { secaoColuna, type PerfilVeiculo } from '../../dominio/didatico/perfilVeiculo'
import { deArray } from '../../dominio/geometria/vetor3'
import { Barra } from '../componentes/Barra'
import { FaceDeCorte } from '../veiculo/Seccionado'
import type { IdPortaOficina } from './zonasOperacaoPorta'
import { pontosRebatimentoPainel } from './zonasRebatimentoPainel'

export function ColunaARebatida3D({ perfil, idPorta, estado, deslocamento }: {
  perfil: PerfilVeiculo; idPorta: IdPortaOficina; estado: EstadoRebatimentoPainel; deslocamento: number
}) {
  const { coluna, yBase, yMedio, topoDobradicas, baseSuperiorA } = pontosRebatimentoPainel(perfil, idPorta)
  const id = `colunaA${idPorta.endsWith('Esquerda') ? 'Esquerda' : 'Direita'}`
  const folgaBase = estado.corteAlivio ? 0.015 : 0
  const folgaMedia = estado.corteMedio ? 0.015 : 0
  const trechos: Array<[[number, number, number], [number, number, number]]> = [
    [coluna(perfil.topoSoleiraY - 0.03, 0), coluna(yBase - folgaBase, 0)],
    [coluna(yBase + folgaBase, deslocamento), topoDobradicas(deslocamento)],
    [topoDobradicas(deslocamento), baseSuperiorA(deslocamento)],
    [baseSuperiorA(deslocamento), coluna(yMedio - folgaMedia, deslocamento)],
    [coluna(yMedio + folgaMedia, 0), coluna(perfil.tetoY, 0)],
  ]
  return <group name="coluna-a-rebatimento">
    {trechos.map(([de, para], i) => <Barra key={i} id={id} de={deArray(de)} para={deArray(para)} largura={secaoColuna('A').largura} espessura={secaoColuna('A').espessura} />)}
    {estado.corteAlivio && <>
      <FaceDeCorte posicao={coluna(yBase - folgaBase)} eixo="y" raio={0.052} />
      <FaceDeCorte posicao={coluna(yBase + folgaBase, deslocamento)} eixo="y" raio={0.052} />
    </>}
    {estado.corteMedio && <>
      <FaceDeCorte posicao={coluna(yMedio - folgaMedia, deslocamento)} eixo="y" raio={0.052} />
      <FaceDeCorte posicao={coluna(yMedio + folgaMedia)} eixo="y" raio={0.052} />
    </>}
  </group>
}
